import type { Option } from "src/components/form/select/Select"

export const previousOwnersOptions: Option[] = Array.from(Array(11).keys(), (val) => ({
	label: `${val}`,
	value: `${val}`,
}))
